import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from 'uuid/v4';
import Select from 'react-select';
import GenericButton from '../GenericButton';
import ColorPicker from '../ColorPicker';

import HighlightAndFilterItems from './HighlightAndFilterItems';
import HighlightOptionsRenderer from './HighlightOptionsRenderer';
import HighlightOptionValue from './HighlightOptionValue';

import highLightIconModel from '../../../images/highlight-icon.png';
import removeIconModel from '../../../images/remove-icon.png';
import sampleIconModel from '../../../images/sample-icon_model.png';
import weightedIconModel from '../../../images/weighted-icon_modal.png';
import verticalIconModel from '../../../images/vertical-icon-down_darkblue.png';
import horizontalIconModel from '../../../images/horizontal-icon_modal.png';
import indexIconModel from '../../../images/index-icon_modal.png';
import metricesIconModel from '../../../images/metrics-icon.png';

import highLightIconModelWhite from '../../../images/highlight-icon_white.png';
import removeIconModelWhite from '../../../images/remove-icon_white.png';
import sampleIconModelWhite from '../../../images/sample-icon_white.png';
import weightedIconModelWhite from '../../../images/weighted-icon_white.png';
import verticalIconModelWhite from '../../../images/vertical-icon-down_white.png';
import horizontalIconModelWhite from '../../../images/horizontal-icon_white.png';
import indexIconModelWhite from '../../../images/index-icon_white.png';
// import metricesIconModelWhite from '../../../images/metrics-icon_white.png';

import greaterIconModel from '../../../images/greater-than-icon.png';
import lessIconModel from '../../../images/less-than-icon.png';
import equalIconModel from '../../../images/equal-icon.png';
import betweenIconModel from '../../../images/between-icon.png';

import greaterIconModelWhite from '../../../images/greater-than-icon_white.png';
import lessIconModelWhite from '../../../images/less-than-icon_white.png';
import equalIconModelWhite from '../../../images/equal-icon_white.png';
import betweenIconModelWhite from '../../../images/between-icon_white.png';

import * as urls from '../../../actions/urlTypes';
import { HJ_CROSSTAB_HIGHLIGHTING_FILTERING_APPLY } from '../../../hotjarConstants';
import { sendVPVHotjarEvent } from '../../../util/hotjarUtils';
import { CROSSTAB_CELL_HIGHLIGHT_FILTERING_APPLY } from '../../../trackerConstants';
import { saveTrackingData } from '../../../util/trackerUtils';

const METRICS = [
  { key: 'horizontal', content: 'Horizontal' },
  { key: 'index', content: 'Index' },
  { key: 'sample', content: 'Sample' },
  { key: 'vertical', content: 'Vertical' },
  { key: 'weighted', content: 'Weighted' },
];

const Metrices = [
  {
    label: 'Sample',
    value: 'Sample',
    icon: sampleIconModel,
    selectedIcon: sampleIconModelWhite,
  },
  {
    label: 'Weighted',
    value: 'Weighted',
    icon: weightedIconModel,
    selectedIcon: weightedIconModelWhite,
  },
  {
    label: 'Vertical %',
    value: 'Vertical',
    icon: verticalIconModel,
    selectedIcon: verticalIconModelWhite,
  },
  {
    label: 'Horizontal %',
    value: 'Horizontal',
    icon: horizontalIconModel,
    selectedIcon: horizontalIconModelWhite,
  },
  {
    label: 'Index',
    value: 'Index',
    icon: indexIconModel,
    selectedIcon: indexIconModelWhite,
  },
];

const MetricesOption = [
  {
    label: 'Greater Than',
    value: 'Greater Than',
    icon: greaterIconModel,
    selectedIcon: greaterIconModelWhite,
  },
  {
    label: 'Less Than',
    value: 'Less Than',
    icon: lessIconModel,
    selectedIcon: lessIconModelWhite,
  },
  {
    label: 'Equals',
    value: 'Equals',
    icon: equalIconModel,
    selectedIcon: equalIconModelWhite,
  },
  {
    label: 'Between',
    value: 'Range',
    icon: betweenIconModel,
    selectedIcon: betweenIconModelWhite,
  },
];

const MetricesOptionHnF = [
  {
    label: 'Highlight Matching Cells in Result',
    value: 'Highlight',
    icon: highLightIconModel,
    selectedIcon: highLightIconModelWhite,
  },
  {
    label: 'Remove Matching Cells from Result',
    value: 'Remove',
    icon: removeIconModel,
    selectedIcon: removeIconModelWhite,
  },
];

const HNF = ['highlight', 'filter'];

const placeholderStyle = {
  borderRadius: 3,
  display: 'inline-block',
  marginRight: 10,
  position: 'relative',
  top: -2,
  verticalAlign: 'middle',
  width: '20px',
};

class Highlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTextColorPickerVisible: false,
      isCellColorPickerVisible: false,
      isHighlight: true,
      textButtonColor: '#000',
      cellButtonColor: '#ffffff',
      textColorCheckbox: true,
      cellColorCheckbox: false,
      ButtonOneText: '',
      ButtonTwoText: '',
      ActionButtonValue: '',
      InputValue: '',
      InputValueUF: '',
      range: '0 to 0',
      items: [],
    };
  }

  UNSAFE_componentWillMount() {
    const itemData = [];
    if (this.props.tableData.highlightAndFilter) {
      METRICS.map(({ key, content }) => {
        HNF.map(id =>
          this.props.tableData.highlightAndFilter[key][id].map(
            ({ operator, textColor, cellColor, value }) =>
              itemData.push({
                key: uuid(),
                ButtonOneText: content,
                ButtonTwoText: operator,
                textColor,
                cellColor,
                InputValue: value,
                isHighlight: id === 'highlight',
                selected: false,
              })
          )
        );
        return false;
      });
      this.setState({
        isTextColorPickerVisible: false,
        isCellColorPickerVisible: false,
        isHighlight: true,
        textButtonColor: '#000',
        cellButtonColor: '#fff',
        textColorCheckbox: true,
        cellColorCheckbox: false,
        ButtonOneText: '',
        ButtonTwoText: '',
        ActionButtonValue: '',
        InputValue: '',
        range: '0 to 0',
        items: itemData,
      });
    }
  }

  getColor = (selectedElementId, type) => {
    let color;
    if (type === 'text') {
      this.state.items.forEach(element => {
        if (element.key === selectedElementId) {
          color = element.textColor;
        }
      });
    } else {
      this.state.items.forEach(element => {
        if (element.key === selectedElementId) {
          color = element.cellColor;
        }
      });
    }
    return color;
  };

  hfInputHandle = e => {
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      e.keyCode === 190 ||
      e.keyCode === 188 ||
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      e.keyCode === 37 ||
      e.keyCode === 39
    ) {
      return true;
    }
    e.preventDefault();
    return false;
  };

  handleInputChange = event => {
    if (event.target.id === 'defaultValue') {
      this.setState({
        InputValueUF: event.target.value,
        InputValue: parseFloat(event.target.value.replace(/,/g, '')),
      });
    } else {
      let range =
        event.target.id === 'fromValue'
          ? `${event.target.value} to ${this.state.range.split(' to ')[1]}`
          : `${this.state.range.split(' to ')[0]} to ${event.target.value}`;
      const arrRange = range.split(' to ');
      range = `${parseFloat(arrRange[0].replace(/,/g, ''))} to ${parseFloat(
        arrRange[1].replace(/,/g, '')
      )}`;
      this.setState({ range, InputValue: range });
    }
  };

  handleButtonGroupOne = value => {
    this.setState({ ButtonOneText: value.value });
  };

  handleButtonGroupTwo = value => {
    const name = value.value;
    if (this.state.ButtonTwoText === 'Range' && name !== 'Range') {
      this.setState({ InputValue: '0' });
    } else if (this.state.ButtonTwoText !== 'Range' && name === 'Range') {
      this.setState({ InputValue: '0 to 0' });
    }
    this.setState({ ButtonTwoText: name });
  };

  handleTextColorPicker() {
    this.setState({
      isTextColorPickerVisible: !this.state.isTextColorPickerVisible,
      isCellColorPickerVisible: false,
    });
    this.handleCheckboxChange('textColorCheckbox');
  }

  handleCellColorPicker() {
    this.setState({
      isCellColorPickerVisible: !this.state.isCellColorPickerVisible,
      isTextColorPickerVisible: false,
    });
    this.handleCheckboxChange('cellColorCheckbox');
  }

  handleCellAction = value =>
    this.setState({
      isHighlight: value.value === 'Highlight',
      ActionButtonValue: value.value,
    });

  handleTextColorChange = (color, button) => {
    if (button === 'textColor') {
      this.setState({ textButtonColor: color.hex });
      this.handleTextColorPicker();
    } else {
      this.setState({ cellButtonColor: color.hex });
      this.handleCellColorPicker();
    }
  };

  addSelected = () => {
    const selections = this.state.items;
    const itemData = [
      {
        key: uuid(),
        ButtonOneText: this.state.ButtonOneText,
        ButtonTwoText: this.state.ButtonTwoText,
        textColor: this.state.textColorCheckbox
          ? this.state.textButtonColor
          : false,
        cellColor: this.state.cellColorCheckbox
          ? this.state.cellButtonColor
          : false,
        InputValue: this.state.InputValue,
        isHighlight: this.state.isHighlight,
        selected: false,
      },
    ];
    itemData.map(item => {
      selections.push(item);
      return item;
    });
    this.setState({
      items: selections,
    });
    this.setState({
      isTextColorPickerVisible: false,
      isCellColorPickerVisible: false,
      isHighlight: true,
      textButtonColor: '#000',
      cellButtonColor: '#fff',
      textColorCheckbox: true,
      cellColorCheckbox: false,
      ButtonOneText: '',
      ButtonTwoText: '',
      ActionButtonValue: '',
      InputValue: '',
      InputValueUF: '',
      range: '0 to 0',
    });
  };

  removeSelected = deleteKey =>
    this.setState({
      items: this.state.items.filter(({ key }) => key !== deleteKey),
    });

  handleRuleSelection = selectedElementId =>
    this.setState({
      items: this.state.items.map(item => ({
        ...item,
        selected: item.key === selectedElementId,
      })),
      textButtonColor: this.getColor(selectedElementId, 'text') || '#000',
      cellButtonColor: this.getColor(selectedElementId, 'cell') || '#fff',
    });

  handleOk = () => {
    const highlightAndFilter = this.state.items.reduce(
      (accumulator, currentValue) => {
        if (currentValue.isHighlight) {
          accumulator[currentValue.ButtonOneText.toLowerCase()].highlight.push({
            value: currentValue.InputValue,
            operator: currentValue.ButtonTwoText,
            textColor: currentValue.textColor,
            cellColor: currentValue.cellColor,
          });
        } else {
          accumulator[currentValue.ButtonOneText.toLowerCase()].filter.push({
            value: currentValue.InputValue,
            operator: currentValue.ButtonTwoText,
          });
        }

        return accumulator;
      },
      {
        sample: { highlight: [], filter: [] },
        weighted: { highlight: [], filter: [] },
        vertical: { highlight: [], filter: [] },
        horizontal: { highlight: [], filter: [] },
        index: { highlight: [], filter: [] },
      }
    );
    this.props.handleConditionalFiltering('HNF');

    this.props.handleHighlightAndFilter(highlightAndFilter);
    this.props.handleRadioOptions(true);
    sendVPVHotjarEvent(HJ_CROSSTAB_HIGHLIGHTING_FILTERING_APPLY);

    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo: this.props.crosstabStudy.pn,
      moduleName: 'crosstab',
      action: CROSSTAB_CELL_HIGHLIGHT_FILTERING_APPLY,
      attributes: { highlightAndFilterParams: highlightAndFilter },
    });
  };

  handleCheckboxChange = checkbox => {
    if (checkbox === 'textColorCheckbox') {
      this.setState({ textColorCheckbox: true });
    } else {
      this.setState({ cellColorCheckbox: true });
    }
  };

  renderInput = () => {
    if (this.state.ButtonTwoText !== 'Range') {
      return (
        <div className="inline">
          <label htmlFor="defaultValue">
            <input
              type="text"
              id="defaultValue"
              placeholder="Enter Value"
              value={this.state.InputValueUF}
              onKeyDown={e => this.hfInputHandle(e)}
              onChange={this.handleInputChange}
            />
          </label>
          {this.state.ButtonOneText === 'Vertical' ||
          this.state.ButtonOneText === 'Horizontal' ? (
            <span className="percent-align">%</span>
          ) : (
            ''
          )}
        </div>
      );
    }
    return (
      <div>
        <div className="inline width-37">
          <label className="width-80p" htmlFor="fromValue">
            <input
              type="text"
              id="fromValue"
              placeholder="Enter Value"
              onKeyDown={e => this.hfInputHandle(e)}
              onChange={this.handleInputChange}
            />
          </label>
          {this.state.ButtonOneText === 'Vertical' ||
          this.state.ButtonOneText === 'Horizontal' ? (
            <span className="percent-align">%</span>
          ) : (
            ''
          )}
        </div>
        <div className="and-text">AND</div>
        <div className="inline width-37">
          <label className="width-80p" htmlFor="toValue">
            <input
              type="text"
              id="toValue"
              placeholder="Enter Value"
              onKeyDown={e => this.hfInputHandle(e)}
              onChange={this.handleInputChange}
            />
          </label>
          {this.state.ButtonOneText === 'Vertical' ||
          this.state.ButtonOneText === 'Horizontal' ? (
            <span className="percent-align">%</span>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  };

  renderPlaceholder = (icon, text) => (
    <div>
      <img style={placeholderStyle} src={icon} alt={text} />
      <span>{text}</span>
    </div>
  );

  render() {
    return (
      <div className="row expanded highlightnfilters">
        <div className="large-12 columns padding-0">
          <div className="row expanded">
            <div className="large-12 cross-buttons-border">
              <h4 className="margin-top-0">When Item Matches This:</h4>
              <div className="row expanded">
                <div className="large-3 padding-left-0 columns metrics">
                  <Select
                    name="form-field-name"
                    clearable={false}
                    searchable={false}
                    optionComponent={HighlightOptionsRenderer}
                    options={Metrices}
                    onChange={val => this.handleButtonGroupOne(val)}
                    valueComponent={HighlightOptionValue}
                    value={this.state.ButtonOneText}
                    placeholder={this.renderPlaceholder(
                      metricesIconModel,
                      'METRICS'
                    )}
                  />
                </div>
                <div className="is-text">IS</div>
                <div className="large-3 columns">
                  <Select
                    name="form-field-name"
                    clearable={false}
                    searchable={false}
                    optionComponent={HighlightOptionsRenderer}
                    options={MetricesOption}
                    onChange={val => this.handleButtonGroupTwo(val)}
                    valueComponent={HighlightOptionValue}
                    value={this.state.ButtonTwoText}
                    placeholder={this.renderPlaceholder(
                      equalIconModel,
                      'FUNCTION'
                    )}
                  />
                </div>
                <div className="large-5 columns float-left padding-0">
                  <div className="inline">{this.renderInput()}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="cross-buttons-border">
            <div className="row expanded margin-bottom20">
              <h4>Perform This Action:</h4>
              <div className="large-5 columns padding-0">
                <Select
                  name="form-field-name"
                  clearable={false}
                  searchable={false}
                  optionComponent={HighlightOptionsRenderer}
                  options={MetricesOptionHnF}
                  onChange={val => this.handleCellAction(val)}
                  valueComponent={HighlightOptionValue}
                  value={this.state.ActionButtonValue}
                  placeholder={this.renderPlaceholder(
                    highLightIconModel,
                    'HIGHLIGHT AND FILTERING OPTIONS'
                  )}
                />
              </div>

              <div className="large-7 columns">
                <div
                  className={
                    this.state.ActionButtonValue === 'Remove' ? 'hide' : ''
                  }
                >
                  <div className="large-12">
                    <div className="row expanded">
                      <div className="large-5 display-inline position-relative">
                        {/* <input
                          id="textColorCheckbox"
                          type="checkbox"
                          checked={this.state.textColorCheckbox}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="val1">Text Color:</label> */}
                        <button
                          name="textColor"
                          className="button width-100p color-btn text"
                          style={{
                            backgroundColor: '#ffffff',
                            color: this.state.textButtonColor,
                          }}
                          onClick={() => this.handleTextColorPicker()}
                          /* {...!(this.state.textColorCheckbox) ? { disabled: true } : {}} */
                        >
                          <span className="svg-position">
                            <svg
                              version="1.1"
                              xmlns={urls.W3_2000_SVG}
                              xmlnsXlink={urls.W3_1999_XLINK}
                              x="0px"
                              y="0px"
                              viewBox="0 0 50 50"
                              xmlSpace="preserve"
                              width={20}
                              height={20}
                            >
                              <g
                                className="nc-icon-wrapper"
                                fill={this.state.textButtonColor}
                              >
                                <polyline
                                  data-cap="butt"
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeMiterlimit={10}
                                  points="12,30 22,2 26,2 36,30 "
                                  strokeLinejoin="miter"
                                  strokeLinecap="butt"
                                />
                                <line
                                  data-cap="butt"
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeMiterlimit={10}
                                  x1="16.28572"
                                  y1={18}
                                  x2="31.71428"
                                  y2={18}
                                  strokeLinejoin="miter"
                                  strokeLinecap="butt"
                                />
                                <line
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeLinecap="square"
                                  strokeMiterlimit={10}
                                  x1={8}
                                  y1={30}
                                  x2={16}
                                  y2={30}
                                  strokeLinejoin="miter"
                                />
                                <line
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeLinecap="square"
                                  strokeMiterlimit={10}
                                  x1={32}
                                  y1={30}
                                  x2={40}
                                  y2={30}
                                  strokeLinejoin="miter"
                                />
                                <rect
                                  data-color="color-2"
                                  x={2}
                                  y={38}
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeLinecap="square"
                                  strokeMiterlimit={10}
                                  width={44}
                                  height={8}
                                  strokeLinejoin="miter"
                                />
                              </g>
                            </svg>
                          </span>
                          Text
                        </button>
                        <div
                          className={
                            this.state.isTextColorPickerVisible
                              ? 'color-picker-position'
                              : 'color-picker-position showComponent'
                          }
                        >
                          <ColorPicker
                            button="textColor"
                            color={this.state.textButtonColor}
                            handleTextColorChange={this.handleTextColorChange}
                          />
                        </div>
                      </div>
                      <div className="large-5 margin-left20 display-inline position-relative">
                        {/* <input
                          id="cellColorCheckbox"
                          type="checkbox"
                          checked={this.state.cellColorCheckbox}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="val1">Cell Color:</label> */}
                        <button
                          name="cellColor"
                          className="button width-100p color-btn cell"
                          style={{
                            backgroundColor: this.state.cellButtonColor,
                            color: this.state.textButtonColor,
                          }}
                          onClick={() => this.handleCellColorPicker()}
                          /* {...!(this.state.cellColorCheckbox) ? { disabled: true } : {}} */
                        >
                          <span className="svg-position">
                            <svg
                              version="1.1"
                              xmlns={urls.W3_2000_SVG}
                              xmlnsXlink={urls.W3_1999_XLINK}
                              x="0px"
                              y="0px"
                              viewBox="0 0 50 50"
                              xmlSpace="preserve"
                              width={20}
                              height={20}
                            >
                              <g
                                className="nc-icon-wrapper"
                                fill={this.state.textButtonColor}
                              >
                                <path
                                  data-cap="butt"
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeMiterlimit={10}
                                  d="M4.8,24L26,39.6 c1.6,1.6,6.3-0.7,10.6-4.9s6.5-9,4.9-10.6L26,2.8"
                                  strokeLinejoin="miter"
                                  strokeLinecap="butt"
                                />
                                <ellipse
                                  transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.9757 14.8409)"
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeLinecap="square"
                                  strokeMiterlimit={10}
                                  cx="15.4"
                                  cy="13.4"
                                  rx={15}
                                  ry={6}
                                  strokeLinejoin="miter"
                                />
                                <path
                                  data-color="color-2"
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeLinecap="square"
                                  strokeMiterlimit={10}
                                  d="M2,40 c0-2.2,4-8,4-8s4,5.8,4,8s-1.8,4-4,4S2,42.2,2,40z"
                                  strokeLinejoin="miter"
                                />
                                <path
                                  fill="none"
                                  stroke={this.state.textButtonColor}
                                  strokeWidth={4}
                                  strokeLinecap="square"
                                  strokeMiterlimit={10}
                                  d="M24,22h8c4.4,0,8-3.6,8-8v0 c0-4.4-3.6-8-8-8h-3.6"
                                  strokeLinejoin="miter"
                                />
                              </g>
                            </svg>
                          </span>
                          Background
                        </button>
                        <div
                          className={`color-picker-position ${
                            this.state.isCellColorPickerVisible
                              ? ''
                              : 'showComponent'
                          }`}
                        >
                          <ColorPicker
                            button="cellColor"
                            color={this.state.cellButtonColor}
                            handleTextColorChange={this.handleTextColorChange}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="row expanded">
                      <div className="large-4 columns">
                        <h5>Sample:</h5>
                      </div>
                      <div className="large-8 columns">
                        <input
                          type="text"
                          value="12345"
                          style={{
                            color: this.state.textColorCheckbox
                            ? this.state.textButtonColor
                            : undefined,
                            backgroundColor: this.state.cellColorCheckbox
                              ? this.state.cellButtonColor
                              : undefined,
                          }}
                          disabled
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row expanded">
              <div className="large-12 columns padding-0">
                <GenericButton
                  name="Add New Rule"
                  btnStyle="button newrule-btn"
                  onBtnClick={this.addSelected}
                  {...(this.state.ButtonOneText === '' ||
                  this.state.ButtonTwoText === ''
                    ? { btnDisabled: true }
                    : {})}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="large-12 columns cross-buttons-border padding-0">
          <div className="row expanded">
            <div className="">
              <h4>Highlight And Filter Rules:</h4>
            </div>
            {/* this.state.items && this.state.items.length > 0
              ? <GenericButton name="" btnStyle="position-btn"
                onBtnClick={this.removeSelected} /> : false
             */}
            <div className="columns padding-left-0 padding-right-0 margin-bottom-15">
              <HighlightAndFilterItems
                items={this.state.items}
                handleRuleSelection={this.handleRuleSelection}
                removeSelected={this.removeSelected}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer padding-0">
          <div className="large-12">
            <div className="float-right">
              {/* <GenericButton
                name="Cancel"
                btnStyle="button button-125px btn-cncl float-right"
                onBtnClick={() => this.props.handleParentHide()}
              /> */}
              <GenericButton
                name="Apply"
                btnStyle="button apply-btn float-right"
                {...(this.state.items.length < 1 ? { btnDisabled: true } : {})}
                onBtnClick={() => {
                  this.handleOk();
                  this.props.handleParentHide();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Highlight.propTypes = {
  handleParentHide: PropTypes.func,
  handleHighlightAndFilter: PropTypes.func,
  handleRadioOptions: PropTypes.func,
  handleConditionalFiltering: PropTypes.func,
  tableData: PropTypes.shape({
    highlightAndFilter: PropTypes.shape({}),
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
  };
}

export default connect(mapStateToProps)(React.memo(Highlight));
